import { IconName, InphiniteThemeColors } from '@facephi/ui-react';

export type PermissionsBoxStyleProps = {
  isDraggable?: boolean;
  isEdit?: boolean;
  isClosable?: boolean;
  disabled?: boolean;
};

export type RawPermissionType = {
  id: string;
  label: string;
  parent?: string;
  name?: string;
  permissions?: Array<RawPermissionType>;
};

export type PermissionType = {
  iconName: IconName;
  color: InphiniteThemeColors;
  label: string;
} & RawPermissionType;

export const TYPES_MANAGEMENT = ['users', 'groups'];
